import NodeManager from "../../web/tools/NodeManager";
export var GestureStateManager = {
    create: function create(handlerTag) {
        return {
            begin: function() {
                NodeManager.getHandler(handlerTag).begin();
            },
            activate: function() {
                NodeManager.getHandler(handlerTag).activate();
            },
            fail: function() {
                NodeManager.getHandler(handlerTag).fail();
            },
            end: function() {
                NodeManager.getHandler(handlerTag).end();
            }
        };
    }
};
